module.exports = __webpack_public_path__ + "bc.no1.bbcd7d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bc.no1.jpg
// module id = 8AS+
// module chunks = 0